import { render, staticRenderFns } from "./__store_shelf.vue?vue&type=template&id=f0bea1a4&"
import script from "./__store_shelf.vue?vue&type=script&lang=js&"
export * from "./__store_shelf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports